<template>
  <div id="map-container">
    <div class="button-container">
      <!--
      <el-button class="delete-zone" @click="removePath">
        <i class="fas fa-eraser"></i>
      </el-button>
      <el-button class="start-draw" @click="addPath" >
        <i class="fas fa-pencil-alt"></i>
      </el-button>
      -->
    </div>
    <div id="route-map" v-bind:style="{ height }"></div>
  </div>
</template>

<script>
import GoogleMapsLoader from './config';
import { TaskQueue } from '../../../mixins/taskQueue';

export default {
  name: 'MapZonesModify',
  data() {
    return {
      center: {
        lat: -33.435774,
        lng: -70.660690,
      },
      paths: [],
      polygon: [],
      mvcPaths: '',
      zoom: 12,
      editPoligon: false,
      editDraggable: false,
      // nueva
      clustering: [],
      google: null,
      infoWindows: [],
      map: null,
      markers: [],
      zoomControl: true,
      taskQueue: new TaskQueue(350),
      drawingManager: null,
      selectedShape: null,
      selectedColor: null,
      polyOptions: {
        strokeWeight: 1,
        fillOpacity: 0.45,
        editable: true,
        draggable: true,
      },
    };
  },
  props: {
    lat: {
      type: Number,
      default: -33.435774,
    },
    lng: {
      type: Number,
      default: -70.660690,
    },
    locations: {
      type: Array,
      default() {
        return [];
      },
    },
    height: {
      type: String,
      default: 'calc(100vh - 220px)',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  methods: {
    initMap() {
      const element = document.getElementById('route-map');
      GoogleMapsLoader.load((google) => {
        this.google = google;
        this.map = new google.maps.Map(element, {
          center: new google.maps.LatLng(this.lat, this.lng),
          zoom: 8,
          // zoomControl: this.zoomControl,
          /*
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_RIGHT,
          },
         */
        });
        this.controlDiv = document.createElement('div');
        this.controlDiv.style.display = 'none';
        const controlUI = document.createElement('div');
        controlUI.style.backgroundColor = '#707070';
        controlUI.style.border = '2px solid #707070';
        controlUI.style.borderRadius = '3px';
        controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        controlUI.style.cursor = 'pointer';
        controlUI.style.marginBottom = '22px';
        controlUI.style.marginTop = '10px';
        controlUI.style.textAlign = 'center';
        controlUI.style.width = '200px';
        // this.controlDiv.appendChild(controlUI);
        // Set CSS for the control interior.
        const controlText = document.createElement('div');
        controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
        controlText.style.fontSize = '16px';
        controlText.style.color = 'white';
        controlText.style.lineHeight = '20px';
        controlText.innerHTML = 'Cargando Rutas';
        controlUI.appendChild(controlText);
        this.controlDiv.index = 1;
        this.controlPB = document.createElement('div');
        this.controlPB.style.backgroundColor = '#a7d500';
        this.controlPB.style.height = '10px';
        this.controlPB.style.width = '6%';
        // controlUI.appendChild(this.controlPB);
        this.controlDiv.index = 1;
        // this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(this.controlDiv);
      });
    },
    setSelection(shape) {
      this.selectedShape = shape;
    },
    clearSelection() {
      this.selectedShape = null;
    },
    starDrawing() {
      this.deleteSelectedShape();
      this.drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        markerOptions: {
          draggable: true,
        },
        polylineOptions: {
          editable: true,
          draggable: true,
        },
        // rectangleOptions: this.polyOptions,
        // circleOptions: this.polyOptions,
        polygonOptions: this.polyOptions,
        map: this.map,
      });
      this.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
        const newShape = e.overlay;
        newShape.type = e.type;
        if (e.type !== this.google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          this.drawingManager.setDrawingMode(null);
          // Add an event listener that selects the newly-drawn shape when the user
          // mouses down on it.
          this.google.maps.event.addListener(newShape, 'click', (ev) => {
            if (ev.vertex !== undefined) {
              if (newShape.type === this.google.maps.drawing.OverlayType.POLYGON) {
                const path = newShape.getPaths().getAt(ev.path);
                path.removeAt(ev.vertex);
                if (path.length < 3) {
                  newShape.setMap(null);
                }
              }
              if (newShape.type === this.google.maps.drawing.OverlayType.POLYLINE) {
                const path = newShape.getPath();
                path.removeAt(ev.vertex);
                if (path.length < 2) {
                  newShape.setMap(null);
                }
              }
            }
            this.setSelection(newShape);
          });
          this.setSelection(newShape);
        }
      });
      // eslint-disable-next-line
      this.google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', this.clearSelection);
      this.google.maps.event.addListener(this.map, 'click', this.clearSelection);
      // eslint-disable-next-line
      // this.google.maps.event.addDomListener(document.getElementById('delete-button'), 'click', this.deleteSelectedShape);
    },
    deleteSelectedShape() {
      if (this.selectedShape) {
        this.selectedShape.setMap(null);
      }
    },
    // antiguo
    newPath() {
      this.starDrawing();
    },
    centerMap(lng, lat, zoom) {
      this.map.setCenter(new this.google.maps.LatLng(lat, lng));
      this.map.setZoom(zoom);
    },
    updatePath(poly) {
      const bounds = new this.google.maps.LatLngBounds();
      const poligon = poly.replace('POLYGON((', '').replace('))', '');
      const coor = poligon.split(',');
      const coorArray = [];
      coor.forEach((e) => {
        const PointCoor = e.split(' ');
        const point = {
          lat: parseFloat(PointCoor[1]),
          lng: parseFloat(PointCoor[0]),
        };
        coorArray.push(point);
        const pointBounds = new this.google.maps.LatLng(point.lat, point.lng);
        bounds.extend(pointBounds);
      });
      // this.paths = coorArray;
      if (this.selectedShape !== null) {
        this.selectedShape.setMap(null);
      }
      const flightPath = new this.google.maps.Polygon({
        path: coorArray,
        strokeWeight: 1,
        fillOpacity: 0.45,
        fillColor: '#000000',
      });
      this.setSelection(flightPath);
      this.selectedShape.setMap(this.map);
      this.map.fitBounds(bounds);
    },
    updateEdited(mvcPaths) {
      // this.editablePoligon = true;
      this.mvcPaths = mvcPaths;
      this.polygon = [];
      // eslint-disable-next-line
      let poligonStr = [];
      this.mvcPaths.g[0].g.forEach((e) => {
        poligonStr.push(`${e.lng()} ${e.lat()}`);
      });
      poligonStr.push(`${this.mvcPaths.g[0].g[0].lng()} ${this.mvcPaths.g[0].g[0].lat()}`);
      const result = `POLYGON((${poligonStr.join(',')}))`;
      this.$emit('submit', result);// this.oString(this.polygon));
    },
    getPolygonPath() {
      if (this.selectedShape != null) {
        // eslint-disable-next-line
        const objSelectedShape = JSON.parse(JSON.stringify(this.selectedShape.getPath().getArray()));
        const poligonStr = [];
        objSelectedShape.forEach((e) => {
          poligonStr.push(`${e.lng} ${e.lat}`);
        });
        poligonStr.push(`${objSelectedShape[0].lng} ${objSelectedShape[0].lat}`);
        const result = `POLYGON((${poligonStr.join(',')}))`;
        this.$emit('getPolygonPath', result);
      } else {
        const resultFail = '';
        this.$emit('getPolygonPath', resultFail);
      }
    },
  },
  watch: {
    paths() {
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
  div.button-container {
    position: absolute;
    z-index: 2;
    width: 100%;
  }

  .el-button.delete-zone, .el-button.start-draw {
    font-size: 18px;
    color: white;
    background: $fb-grey-light-30 !important;
    box-sizing: border-box;
    margin: 5px;
    transition: all 0.5s ease ;
    border-bottom: 5px solid $fb-green-dark-10;
    border-left: none;
    border-top: none;
    border-right: none;
    max-width: 76px;
    &:hover {
      max-width: 50%;
      margin-right: 0;
      margin-left: 0;
      border-bottom: 5px solid $fb-green;
      border-right: 5px solid $fb-green;
      background: $fb-grey-light-30 !important;
      &::before {
        color: $fb-green;
      }
    }
  }

  .el-button.delete-zone {
    &:hover {
      color: $fb-green;
      &::after {
        font-family: "Lato", sans-serif;
        content: 'Borrar última zona' !important;
        color: white;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        margin-left: 1em;
        white-space: nowrap;
      }
    }
  }

  .el-button.start-draw {
    &:hover {
      color: $fb-green;
      &::after {
        font-family: "Lato", sans-serif;
        content: 'Dibujar zona' !important;
        color: white;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        margin-left: 1em;
        white-space: nowrap;
      }
    }
  }
  /* mapas nuevos*/
  #routeMap {
    width: 100%;
    height: 100vh;
  }
  .infowindowContainer{
    width: 350px!important;
    height: 200px!important;
    text-align: left!important;
    color: #707070!important;
  }
  .titleStyle {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    text-transform: capitalize;
  }
  .addressStyle {
    font-size: 14px;
    font-weight: normal;
    margin: 0;
  }
  .ctName {
    font-size: 14px;
    font-weight: 800;
    margin: 0;
  }
  .nOrderStyle  {
    margin: 5px 0;
  }
  .nOrderStyle span {
    background-color: #9B9B9B;
    color: #FFFFFF;
    font-weight: bold;
    padding: 2px 5px;
    display: inline-block;
  }
  .numberStyle {
    font-size: 13px;
    display: inline-block;
    margin: 0;
  }
  .descriptionStyle {
    margin: 0;
  }
  .genericTitle {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .fa.fa-mobile {
    font-size: 20px;
    margin: 0 5px;
    vertical-align: sub;
    color: #A0BE03;
  }
  .productStyle {
    margin: 5px;
  }
  .productStyle::before {
    content: "• ";
    color: #A0BE03;
  }
</style>
